var _a;
import { TAKEDOWN_STATUS } from '../../../interfaces/createApplication';
export var TAKEDOWN_SURFACE_SX = {
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    p: 2,
};
export var SEARCH_CARD_SX = {
    background: '#F9FAFC',
    borderRadius: '12px',
    p: 2,
    mb: 2,
};
export var INFO_BANNER_SX = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    bgcolor: '#EFF6FF',
    border: '1px solid #BFDBFE',
    borderRadius: '8px',
    p: '12px 16px',
    mb: 2,
};
export var INFO_BANNER_ICON_SX = {
    width: 32,
    height: 32,
    borderRadius: '8px',
    bgcolor: '#1D4ED8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
};
export var EMPTY_STATE_CARD_SX = {
    background: '#fff',
    border: '1px solid #E5E7EB',
    borderRadius: '12px',
    minHeight: 340,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
export var EMPTY_STATE_ICON_SX = {
    width: 96,
    height: 96,
    borderRadius: '50%',
    background: '#F3F4F6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
export var LOC_CARD_SX = {
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    mb: 2,
};
export var LOC_ROW_HEADER_SX = {
    fontSize: '12px',
    color: '#6B7280',
    mb: 0.25,
};
export var LOC_ROW_VALUE_SX = {
    fontSize: '14px',
    fontWeight: 600,
    wordBreak: 'break-word',
};
export var STATUS_COLOR_BY_LOC_STATUS = (_a = {},
    _a[TAKEDOWN_STATUS.Active] = '#15803D',
    _a[TAKEDOWN_STATUS.Expired] = '#B91C1C',
    _a);
export var TAKEDOWN_TABLE_HEAD_ROW_SX = {
    '& .MuiTableCell-head': { background: '#F9FAFB' },
    '& .MuiTableCell-root': {
        padding: '12px 16px',
        borderBottom: '1px solid #E5E7EB',
        fontSize: '13px',
        fontWeight: 600,
    },
};
export var TAKEDOWN_TABLE_BODY_ROW_SX = {
    '&:last-child td, &:last-child th': { border: 0 },
    '& .MuiTableCell-root': { padding: '14px 16px', borderBottom: '1px solid #F3F4F6' },
};
export var TAKEDOWN_DIALOG_PAPER_SX = {
    borderRadius: '12px',
    overflow: 'hidden',
};
export var TAKEDOWN_DIALOG_HEADER_SX = {
    background: '#F3F4F6',
    px: 3,
    py: 2,
};
export var TAKEDOWN_DIALOG_FOOTER_SX = {
    px: 3,
    py: 2,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1.5,
    borderTop: '1px solid #E5E7EB',
};
export var LOC_SUMMARY_TABLE_SX = {
    borderRadius: '12px',
    border: '1px solid #E5E7EB',
    boxShadow: 'none',
};
export var CONTACT_CARD_SX = {
    border: '1px solid #BDBDC2',
    borderRadius: '8px',
    backgroundColor: '#FFF',
    overflow: 'hidden',
};
export var CONTACT_HEADER_SX = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: 2,
    py: 0.5,
    cursor: 'pointer',
};
export var CONTACT_PANEL_SX = {
    display: 'flex',
    gap: 1.5,
    alignItems: 'stretch',
    p: 1,
};
export var CONTACT_SCROLLER_SX = {
    flex: 1,
    minWidth: 0,
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { height: '8px' },
    '&::-webkit-scrollbar-thumb': { backgroundColor: '#C5CCDA', borderRadius: '8px' },
};
export var CONTACT_EMPTY_STATE_SX = {
    border: '1px dashed #BCC5D5',
    borderRadius: '8px',
    px: 2,
    py: 2.5,
    textAlign: 'center',
    bgcolor: '#fff',
};
export var CONTACT_TITLE_CHIP_SX = {
    height: 22,
    fontSize: '12px',
    fontWeight: 500,
    borderRadius: '6px',
    bgcolor: '#EAF1F8',
    color: '#000',
    mb: 1,
    '& .MuiChip-label': { px: '8px' },
};
export var CONTACT_ADD_TILE_SX = {
    flex: '0 0 46px',
    position: 'sticky',
    right: 0,
    border: '1.5px solid #D0D5DE',
    borderRadius: '10px',
    bgcolor: '#EAF0F8',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    gap: 1,
    px: 1.5,
    py: 2,
    '&:hover': { bgcolor: '#DFE8F5' },
};
export var contactTileSx = function (isSelected) { return ({
    flex: { xs: '0 0 270px', md: '0 0 300px' },
    border: '1.5px solid',
    borderColor: isSelected ? '#1F4A93' : '#D0D5DE',
    borderRadius: '10px',
    p: 1.5,
    cursor: 'pointer',
    minHeight: 112,
    boxSizing: 'border-box',
    backgroundColor: isSelected ? '#EDF2FA' : '#fff',
    transition: 'all 0.15s ease',
    '&:hover': { borderColor: '#1F4A93' },
}); };
